import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import Carousel from '../../components/common/Carousel';
import BigCard from '../../components/layout/BigCard';
import { imageUrl } from '../../utils';
import { RoundedArrowButton } from '../../components/buttons';

const clientsArray = [
  {
    name: 'Jacob F.',
    description: 'Atini did an excellent job! For some projects, we knew exactly what we wanted, and for others, we just knew we had a problem—their team was able to suggest solutions that perfectly fit our needs. Atini was incredibly responsive, answering our calls around the clock and genuinely caring about the results. That level of commitment is rare in the contractor space.',
    icon: 'nestbuilder_logo.png',
    role: 'Director of Business Development',
    linkedIn: 'https://www.linkedin.com/in/jacob-fairbank-3b412995/',
  },
  {
    name: 'Josh K.',
    description: 'We had a fantastic experience working with Atini on our Field Force mobile app. From day one, their communication was clear, consistent, and proactive. We always knew where things stood, what was in progress, and what to expect next. The quality of the code they delivered was excellent. Clean, thoughtful implementation with strong attention to detail. They didn’t just ship features — they made sure things were reliable, scalable, and aligned with the bigger picture of our product. What stood out most was their reliability. They did what they said they would do, on time, without drama. When challenges came up, they were solution-oriented and handled them professionally. I would absolutely work with them again and highly recommend them to anyone looking for a dependable, high-quality development partner.',
    icon: 'homeworks_logo.webp',
    role: 'CPO',
    linkedIn: 'https://www.linkedin.com/in/joshkahle/',
  },
  {
    name: 'Kate P.',
    description: "I have worked now with Christine and her team at Atini Studios for a couple of years and I can't say enough wonderful things about them. They are thorough, extremely knowledgable and up to date on all the most current code. They provide solutions and work with me to find the best way to implement what I want done. They work to deadlines and time expectations, and are great communicating to keep me informed as we work. I will continue to work with them in the future.",
    icon: 'poppynotes_logo.png',
    role: 'CEO',
    linkedIn: 'https://www.linkedin.com/in/kate-pitner-7017771b',
  },
  {
    name: 'Andres A.',
    description: "Christine and the entire team at Atini Studio did a phenomenal job. It was a complex project, with multiple levels of dev, and not only did they deliver in a timely manner, but they also took the time to explain to us, in plain English - which was greatly appreciated by all the non-technical folks involved in this project - how to keep repos updated and the best way to provide them with the code, access and privileges they needed. I would 1,000% recommend Christine and their crew. We are already talking about next steps, for a bigger project, with them.",
    icon: 'menopausia_logo.webp',
    role: 'Founder',
    linkedIn: 'https://www.linkedin.com/in/realandyo', 
  },
  {
    name: 'Amir F.',
    description: "It's been an absolute pleasure working with Christine. She is a true professional and has excellent communication skills and, a business work ethic and is very customer-centric. I've worked with other contractors who just focus on billable hours instead of focusing on the customer first and letting payment happen secondarily. I've enjoyed working with Christine in getting our codebase updated from COVID days as well as fixing dozens of pesky bugs that were left over the past several years. Our code is now bug-free and much cleaner for our purposes and I look forward to re-hiring her once we are ready to extend the application. Thanks Christine!",
    icon: 'realtypass_logo.png',
    role: 'Founder',
    linkedIn: 'https://www.linkedin.com/in/agencyone',
  },
  {
    name: 'Elizabeth D.',
    description: "Christine was a dream to work with. She was great at communicating and met every deadline over the course of many months. She was also a good thought partner when it came to brainstorming the 'quick and dirty' way to test / add new features. I really can't recommend her enough. I will be back to work with her again I'm sure!",
    icon: 'stylematch-logo.svg',
    role: 'Founder',
    linkedIn: 'https://www.linkedin.com/in/elizabeth-durand-streisand-b19b2988',
  },
  {
    name: 'Mike L.',
    description: 'Really fantastic experience. Rebuilt an entire (very involved) website for me and couldn’t be happier. Worked with a handful of programmers and Christine and her team were the only ones up for the challenge with the know how I needed',
    icon: 'NER-logo.svg',
    role: 'Founder',
    linkedIn: 'https://www.linkedin.com/in/mike-lombardo-ab880055',
  },  
  // {
  //   name: 'Jason W.',
  //   description:
  //     'I have been working with Christine for several months now and I am very pleased with her knowledge, experience, and abilities. We have been developing a web application to help manage our internal operations and Christine has been able to bring my vision into a reality. Christine is thoughtful about the process and asks good questions to ensure she understands the objective and goals. She has a depth of knowledge in this area and I would recommend her for any web application development.',
  //   icon: 'apexcare_logo.webp',
  //   role: 'President',
  //   linkedIn: 'https://www.linkedin.com/in/jason-wu-1a8891/',
  // },
  // {
  //   name: 'Alireza M.',
  //   description:
  //     'Christine has demonstrated exceptional skills in application development and has successfully created an app that we rely on daily to streamline our business operations. Her attention to detail, technical expertise, and dedication to meeting our specific requirements have been remarkable. Not only has Christine delivered a highly functional and user-friendly application, but she has also been proactive in addressing any issues or modifications we have requested. Her responsiveness and willingness to go the extra mile have made the development process smooth and efficient. On a personal level, I have thoroughly enjoyed collaborating with Christine. Her professionalism, communication skills, and ability to understand our business needs have made her an invaluable partner.',
  //   icon: 'ares_logo.webp',
  //   role: 'Co-Founder',
  //   linkedIn: 'https://www.linkedin.com/in/alireza-mehrnia-84515881',
  // },
  // {
  //   name: 'Mike T.',
  //   description:
  //     "I had the opportunity to work with Christine and her team on a media uploader project with content moderation requirements, and I'm extremely satisfied with their work. They showcased their competence throughout the project, delivering a high-quality solution within the agreed upon timelines. The project required both front-end and back-end development, and the set up of cloudfront on aws. Christine and her team demonstrated a strong understanding of our specific needs and successfully translated them into an efficient and reliable media uploader. Their attention to detail and technical expertise were impressive. What stood out to me was their commitment to meeting deadlines. Christine consistently delivered milestones and updates on time, ensuring a smooth progress of the project. The final result of the media uploader and content moderation solution was excellent. Christine and her team successfully incorporated the necessary features, providing seamless uploading functionality and effective content moderation. The product's functionality and user-friendly interface reflect their exceptional work.",
  //   icon: 'memorabl_logo.png',
  //   role: 'Co-Founder',
  //   linkedIn: 'https://www.linkedin.com/in/mike-taft',
  // },
  // {
  //   name: 'Rustin R.',
  //   description:
  //     "Have worked with dozens of terrific developers on Upwork and Christine is among the best. She's responsive, UI savvy, and delivers a terrific end-product. Couldn't be happier with her work and would hire again in a millisecond.",
  //   icon: 'whatboard_logo.png',
  //   role: 'President',
  //   linkedIn: 'https://www.linkedin.com/in/rustin-ross-713a99238/',
  // },
  // {
  //   name: 'Dennis E.',
  //   description:
  //     'Christine is enjoyable to work with, quick to understand/asks productive questions, and performs quality work! Glad I connected with Christine.',
  //   icon: 'tourgolfleague_logo.png',
  //   role: 'Founder',
  //   linkedIn: 'https://www.linkedin.com/in/dennis-einspahr-b1b2085a/',
  // },
];

const ClientsSection = () => {
  const isLessThan960 = useMediaQuery('(max-width: 960px)');
  const navButtonClasses =
    'flex h-11 w-11 items-center justify-center rounded-full border border-light-black/25 bg-white text-light-black transition-colors duration-200 hover:bg-light-black hover:text-white';

  const BottomElement = (
    <div className="flex w-full flex-col items-center gap-8">
      <Carousel
        containerClasses="w-full"
        dataArray={clientsArray}
        rowsPerSlide={1}
        slidesPerView={isLessThan960 ? 1 : 2}
        leftBtnClassName={'swiper-go-left-clients'}
        rightBtnClassName={'swiper-go-right-clients'}
        calledFrom="clients"
        loop
        autoplay
      />
      <div className="flex items-center gap-4">
        <button
          type="button"
          aria-label="Previous testimonial"
          className={classNames('swiper-go-left-clients', navButtonClasses)}>
          <ArrowBackIcon style={{ fontSize: 20 }} />
        </button>
        <button
          type="button"
          aria-label="Next testimonial"
          className={classNames('swiper-go-right-clients', navButtonClasses)}>
          <ArrowForwardIcon style={{ fontSize: 20 }} />
        </button>
      </div>
    </div>
  );
  const TopRightElement = (
    <div className="flex flex-col w-full mr-0 breaktwo:mr-20 breakthree:mr-0 breakthree:items-center items-end">
      <img
        className="w-[220px] md:w-[300px] max-w-full breakthree:absolute breakthree:right-0 breakthree:top-80 breakthree:opacity-30 breakthree:-z-10 breaktwo:mt-5"
        src={imageUrl('happy_clients_bg.svg')}
        alt="UI/UX Projects showcase Los Angeles"
      />
    </div>
  );

  return (
    <BigCard
      roundInfoText={'Satisfied clients'}
      mainInfoText={
        <div className="breakthree:flex breakthree:flex-col breakthree:items-center">
          <p>{`What our clients say 
 about Atini Studio`}</p>
          <RoundedArrowButton
            text={'View More'}
            containerClasses="bg-light-black w-48 mt-6 mb-8"
            arrowColor="#263238"
            arrowContainerClasses="bg-white"
            typographyStyles={{ color: 'white', fontWeight: 'light' }}
            onClick={() => {
              window?.open('https://www.upwork.com/ag/atinistudio/', '_blank');
            }}
          />
        </div>
      }
      noBorder
      topRightElement={TopRightElement}
      bottomElement={BottomElement}
      bottomContainerClasses="w-[82%]"
      topRightContainerClasses="flex justify-end"
      id="clients"
      fromClients
    />
  );
};

export default ClientsSection;
